import { UserCommReport } from "../actionTypes";
import { getUin, getUAInfo } from "../util";

const info: UserCommReport = {
    uin: getUin(),
    to_uin: 0,
    guid: "",
    longitude: 0,
    latitude: 0,
    city_code: "",
    platform: "",
    client_type: "",
    app_version: "",
    market: "",
    qua: "",
    os_version: "",
    mobile_type: "",
    ip_addr: "",
    network_type: "",
    operators: "",
    qimei: "",
    user_tag: {}
};

const uaInfo = getUAInfo();

info.platform = uaInfo.platform;
info.client_type = uaInfo.client;
info.app_version = uaInfo.appVersion;
info.qua = uaInfo.qua;
info.os_version = uaInfo.version;
info.mobile_type = uaInfo.device;
info.network_type = uaInfo.network;

export default info;
